import { getElementPosition } from './utils';

const accordionClass = 'c-accordion';
const accordionOpenClass = accordionClass + '--open';

const accordionJsClass = 'js-accordion';
const accordionOpenByDefaultJsClass = accordionJsClass + '-open-by-default';
const buttonJsClass = accordionJsClass + '-button';
const contentJsClass = accordionJsClass + '-content';

const accordionElements = document.querySelectorAll('.' + accordionJsClass);
const buttonElements = document.querySelectorAll('.' + buttonJsClass);
const contentElements = document.querySelectorAll('.' + contentJsClass) as NodeListOf<HTMLElement>;

if (buttonElements.length > 0 && contentElements.length > 0 && buttonElements.length === contentElements.length) {
    // We wait for the page to fully load
    window.addEventListener('load', () => {
        buttonElements.forEach((buttonElement: HTMLElement, index: number) => {
            // We add an event listener on the button
            buttonElement.addEventListener('click', () => toggle(index));

            // We get the position of the element in the page
            const position = getElementPosition(buttonElement);

            // We create a unique id for the content
            const contentId = `accordion-content-${position.x}-${position.y}`;
            contentElements[index].id = contentId;

            // We add the aria-controls propery on the button
            buttonElement.setAttribute('aria-controls', contentId);

            // If the accordion is not supposed to be open by default
            if (accordionElements[index] && !accordionElements[index].classList.contains(accordionOpenByDefaultJsClass)) {
                // We close it
                toggle(index);
            } else {
                // Otherwise we keep it open and set it's max height for the transition
                if (contentElements[index]) {
                    contentElements[index].style.maxHeight = contentElements[index].scrollHeight + 'px';
                }
            }
        });
    });
}

function toggle (index: number): void {
    const accordionElement = accordionElements[index];
    const contentElement = contentElements[index];

    if (!accordionElement || !contentElement) {
        return;
    }

    // We toggle the active class
    accordionElement.classList.toggle(accordionOpenClass);

    // If the accordion is closed
    if (contentElement.style.maxHeight === '0px') {
        // We update the content's inert property to allow focus
        contentElement.inert = false;

        // We update the content's max height to open it
        contentElement.style.maxHeight = contentElement.scrollHeight + 'px';

        // We update the aria-expanded property
        buttonElements[index].setAttribute('aria-expanded', 'true');
    } else {
        // We update the content's inert property to prevent focus
        contentElement.inert = true;

        // We update the content's max height to close it
        contentElement.style.maxHeight = '0px';

        // We update the aria-expanded property
        buttonElements[index].setAttribute('aria-expanded', 'false');
    }
}

// We call this when the window is resized to make sure that the accordion's height matches it's content
export function updateAccordions (): void {
    accordionElements.forEach((accordionElement: HTMLElement, index: number) => {
        // If the accordion is open
        if (accordionElement.classList.contains(accordionOpenClass)) {
            if (contentElements[index]) {
                // We update the content's max height
                contentElements[index].style.maxHeight = contentElements[index].scrollHeight + 'px';
            }
        }
    });
}